import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PlaylistsService } from 'src/app/services/data/playlists.service';


interface Video {
  safeUrl: SafeResourceUrl;
  url: string;
}

interface Playlist {
  title: string;
  videos: Video[];
}

@Component({
  selector: 'app-video-section',
  templateUrl: './video-section.component.html',
  styleUrls: ['./video-section.component.scss']
})
export class VideoSectionComponent implements OnInit {
  playlists: Playlist[] = [];
  currentPlaylistIndex = 0;
  currentEpisodeIndex = 0;

  constructor(
    private sanitizer: DomSanitizer,
    private playlistsService: PlaylistsService
  ) {}

  ngOnInit(): void {
    this.loadPlaylists();
  }

  loadPlaylists(): void {
    this.playlistsService.getPlaylists().subscribe(data => {
      this.playlists = data.map(playlist => ({
        title: playlist.title,
        videos: playlist.urls.map((url: string) => ({
          safeUrl: this.sanitizer.bypassSecurityTrustResourceUrl(url.trim()),
          url: url.trim()
        }))
      }));
    });
  }

  get currentPlaylist() {
    return this.playlists[this.currentPlaylistIndex];
  }

  get currentEpisode() {
    return this.currentPlaylist.videos[this.currentEpisodeIndex];
  }

  nextEpisode(): void {
    if (this.currentEpisodeIndex < this.currentPlaylist.videos.length - 1) {
      this.currentEpisodeIndex++;
    }
  }

  previousEpisode(): void {
    if (this.currentEpisodeIndex > 0) {
      this.currentEpisodeIndex--;
    }
  }

  nextPlaylist(): void {
    if (this.currentPlaylistIndex < this.playlists.length - 1) {
      this.currentPlaylistIndex++;
      this.currentEpisodeIndex = 0;
    }
  }

  previousPlaylist(): void {
    if (this.currentPlaylistIndex > 0) {
      this.currentPlaylistIndex--;
      this.currentEpisodeIndex = 0;
    }
  }

  selectPlaylist(index: number): void {
    this.currentPlaylistIndex = index;
    this.currentEpisodeIndex = 0;
  }

  selectEpisode(index: number): void {
    this.currentEpisodeIndex = index;
  }

  getYoutubeThumbnail(url: string): string {
    const videoIdMatch = url.match(/(?:youtube\.com\/embed\/|youtu\.be\/)([^?&]+)/);
    const videoId = videoIdMatch ? videoIdMatch[1] : '';
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  }
}
